import { Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from '@/layout';
import { getUserPermissions, isAuthenticated } from '@/utils/auth';
import { useReCaptchaVisibility } from '@/hooks';
import { publicPages, privatePages } from './pagesData';
import ProtectedRoute from './ProtectedRoute';

const Router = () => {
  const location = useLocation();
  const isLogged = isAuthenticated();

  const accessPages = getUserPermissions();

  useReCaptchaVisibility(location.pathname, isLogged);

  const isPrivateRoute = privatePages.some(
    (page) => page.path === location.pathname
  );

  const publicRouteWithPrivateLayout = publicPages.some(
    (page) => page.path === location.pathname && page.usePrivateLayout
  );

  const usePrivateLayout =
    isPrivateRoute || (publicRouteWithPrivateLayout && isLogged);

  const publicRoutes = publicPages.map(({ path, element }) => (
    <Route key={path} path={path} element={element} />
  ));

  const privateRoutes = privatePages
    .filter(({ name }) => {
      if (!name) return true;
      return accessPages.includes(name);
    })
    .map(({ path, element }) => (
      <Route key={path} element={<ProtectedRoute />}>
        <Route path={path} element={element} />
      </Route>
    ));

  return (
    <Routes>
      <Route
        element={
          <Layout
            isPrivate={usePrivateLayout}
            flexStart={location.pathname.includes('simulador')}
          />
        }
      >
        {publicRoutes}
        {privateRoutes}
      </Route>
    </Routes>
  );
};

export default Router;
